import { render, staticRenderFns } from "./SystemTemplate.vue?vue&type=template&id=179109fd&"
import script from "./SystemTemplate.vue?vue&type=script&lang=js&"
export * from "./SystemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports